/* Product Page CRO — cart upsell.

   Offers refills that FIT the diffuser in the cart: right collection, right
   size. Without the size check the script picked whichever variant came
   first — usually the smallest and cheapest, not the one that fits.

   IMAGES: use the chosen VARIANT's image where it has one. The product's
   featured image is usually the 500 ml bottle, so a 300 ml variant was being
   shown with the wrong bottle.

   "Default Title" is Shopify's placeholder for a product with no real
   options. Never show it to a customer.

   Prices from /collections/<handle>/products.json are DECIMAL STRINGS
   ("284.00"); /cart.js and /products/x.js use CENTS. Do not mix them up. */
(function () {

  var cfg = null;
  var cache = {};
  var busy = false;

  function config() {
    if (cfg) return cfg;
    var el = document.querySelector('[data-cro-cart-config]');
    if (!el) return null;
    try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = null; }
    return cfg;
  }

  function money(v) {
    var n = parseFloat(v);
    return isFinite(n) ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n) : '';
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function realSize(title) {
    if (!title) return '';
    var t = String(title).trim();
    if (/^default title$/i.test(t)) return '';
    return t;
  }

  function urlOf(i) {
    if (!i) return '';
    if (typeof i === 'string') return i;
    if (typeof i.src === 'string') return i.src;
    if (typeof i.url === 'string') return i.url;
    return '';
  }

  /* variant image first, product image only as a fallback */
  function imageFor(v, p) {
    var u = v ? urlOf(v.featured_image) : '';
    if (u) return u;
    if (p && p.images && p.images.length) {
      u = urlOf(p.images[0]);
      if (u) return u;
    }
    return urlOf(p && p.featured_image);
  }

  function pickVariant(p, size) {
    var want = String(size) + 'ml';
    var match = null, first = null;
    (p.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (!first) first = v;
      var t = String(v.title).toLowerCase().replace(/\s/g, '');
      if (!match && t.indexOf(want) > -1) match = v;
    });
    return match || first;
  }

  function loadSingleProduct(handle) {
    var key = 'p:' + handle;
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var list = (p.variants || []).filter(function (v) { return v.available; })
          .map(function (v) {
            return {
              title: v.title,
              variantId: v.id,
              price: (v.price / 100).toFixed(2),
              size: '',
              image: imageFor(v, p),
              url: '/products/' + p.handle + '?variant=' + v.id
            };
          });
        cache[key] = { kind: 'product', productId: p.id, items: list };
        return cache[key];
      })
      .catch(function () { return { kind: 'product', productId: null, items: [] }; });
  }

  function loadCollection(handle, size) {
    var key = 'c:' + handle + ':' + (size || 0);
    if (cache[key]) return Promise.resolve(cache[key]);
    return fetch('/collections/' + handle + '/products.json?limit=50', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ids = {};
        var list = (data.products || []).map(function (p) {
          ids[p.id] = true;
          var v = pickVariant(p, size);
          if (!v) return null;
          return {
            title: String(p.title).replace(/\s*\d+\s*ml\s*$/i, ''),
            variantId: v.id,
            price: v.price,
            size: realSize(v.title),
            image: imageFor(v, p),
            url: '/products/' + p.handle + '?variant=' + v.id
          };
        }).filter(Boolean);
        cache[key] = { kind: 'collection', ids: ids, items: list };
        return cache[key];
      })
      .catch(function () { return { kind: 'collection', ids: {}, items: [] }; });
  }

  function cheapest(list, n) {
    return list.slice().sort(function (a, b) {
      return parseFloat(a.price) - parseFloat(b.price);
    }).slice(0, n);
  }

  function render(root, title, sub, items) {
    var grid    = root.querySelector('[data-cro-cart-grid]');
    var titleEl = root.querySelector('[data-cro-cart-title]');
    var subEl   = root.querySelector('[data-cro-cart-sub]');

    if (!items.length) { root.hidden = true; return; }

    titleEl.textContent = title;
    subEl.textContent = sub;

    grid.innerHTML = items.map(function (o) {
      return '<div class="cro-cart__card">' +
        '<a class="cro-cart__media" href="' + esc(o.url) + '" tabindex="-1" aria-hidden="true">' +
          (o.image ? '<img src="' + esc(o.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a class="cro-cart__name" href="' + esc(o.url) + '">' + esc(o.title) + '</a>' +
        '<span class="cro-cart__price">' + money(o.price) +
          (o.size ? ' <span class="cro-cart__size">' + esc(o.size) + '</span>' : '') +
        '</span>' +
        '<button type="button" class="cro-cart__add" data-cro-cart-add="' + o.variantId +
          '" data-cro-cart-name="' + esc(o.title) + '">Add</button>' +
      '</div>';
    }).join('');

    root.hidden = false;
  }

  function sync() {
    if (busy) return;
    var root = document.querySelector('[data-cro-cart-upsell]');
    var c = config();
    if (!root || !c) return;
    busy = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var entry = null;

        items.forEach(function (i) {
          var id = String(i.product_id);
          if (!entry && c.diffusers[id]) entry = c.diffusers[id];
        });

        if (!entry) { root.hidden = true; busy = false; return; }

        var load = entry.single
          ? loadSingleProduct(entry.source)
          : loadCollection(entry.source, entry.size);

        return load.then(function (data) {
          var hasRefill = items.some(function (i) {
            if (data.kind === 'product') return String(i.product_id) === String(data.productId);
            return data.ids && data.ids[i.product_id];
          });

          if (!hasRefill) {
            render(root,
              'Your diffuser needs a refill',
              'Pick a scent to go with it \u2014 it ships in the same order.',
              data.items.slice(0, 4));
            busy = false;
            return;
          }

          return Promise.all(c.companions.map(function (h) { return loadCollection(h, 0); }))
            .then(function (sets) {
              var picks = [];
              sets.forEach(function (s) {
                var one = cheapest(s.items, 1)[0];
                if (one) picks.push(one);
              });
              render(root,
                'Scent the rest of your space',
                'A diffuser covers the main room. These reach the corners it does not.',
                picks);
              busy = false;
            });
        });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cro-cart-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var root = document.querySelector('[data-cro-cart-upsell]');
    var status = root && root.querySelector('[data-cro-cart-status]');
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.croCartAdd), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not add');
        return r.json();
      })
      .then(function () {
        if (status) {
          status.textContent = (btn.dataset.croCartName || 'Item') + ' added. Updating your cart\u2026';
          status.hidden = false;
        }
        window.location.reload();
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
        if (status) {
          status.textContent = 'Sorry, that could not be added.';
          status.hidden = false;
        }
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  ['cart:refresh', 'cart:build', 'cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(sync, 300); });
  });
})();
